import React from 'react';
import { View, Image } from 'react-native';
import Text from 'src/components/Text/Text';
import { styles } from './loadingTruck.styles';

import truckLoader from 'src/assets/truckLoader.gif';

interface LoaderProps {
  text?: string;
}

const loadingTruck: React.FC<LoaderProps> = ({ text = 'Loading...' }) => (
  <View style={styles.container}>
    <Image
      source={truckLoader}
      style={styles.gif}
      resizeMode="contain"
      accessibilityLabel="Loading animation"
    />
    <Text variant="title1" style={styles.text}>
      {text}
    </Text>
  </View>
);

export default loadingTruck;
